import _ from 'lodash';

export const optInChoices = [
  {label: 'Ja', value: 'true'},
  {label: 'Nee', value: 'false'}
];

export function normalizeOptIns(ctx) {
  const updates = {};
  ['allowTelemarketing', 'allowNewsletter'].forEach(name => {
    const value = _.get(ctx, ['data', name]);
    if (value === 'true' || value === 'false') {
      updates[name] = value === 'true';
    }
  });

  if (!_.isEmpty(updates)) {
    ctx.setValues(updates);
  }
}
